module.exports = __webpack_public_path__ + "img/1479793110.16342d32.jpg";